import { useEffect, useState } from "react";
import { Row, Badge, Spinner } from "react-bootstrap";
import { ArrowUpRight, ArrowDownRight } from "react-bootstrap-icons";
import { makeRESTApiRequests } from "../helpers/api";
import { ENDPOINTS } from "../helpers/constants";
import { toast } from "react-toastify";
import { useParams } from "react-router";

function StatRow({ amount }) {
  const isProfit = amount >= 0;
  const label = isProfit ? "PROFIT" : "LOSS";
  const color = isProfit ? "success" : "danger";
  const Icon = isProfit ? ArrowUpRight : ArrowDownRight;

  const bgStyles = {
    success: {
      backgroundColor: "#d1f2eb",
      color: "#0f5132",
      border: "1px solid #198754",
    },
    danger: {
      backgroundColor: "#f8d7da",
      color: "#721c24",
      border: "1px solid #dc3545",
    },
  };

  return (
    <Row className="align-items-center justify-content-center gap-3 ml-2">
      <dic>
        <div className="d-flex align-items-center">
          <span className={`fw-bolder text-${color} mb-0 px-1`}>
            ${Math.abs(amount).toFixed(2)}
          </span>
          <Icon className={`text-${color}`} size={12} />
        </div>
      </dic>
      <div>
        <Badge
          className="px-2 py-1 fw-bolder xtiny-text rounded-pill"
          style={bgStyles[color]}
        >
          {label}
        </Badge>
      </div>
    </Row>
  );
}

export default function ProfitAndLoss() {
  const [value, setValue] = useState(0);
  const { id } = useParams();
  const [loading, setLoading] = useState(true);

  const fetchProfitOrLoss = async () => {
    const { response, error } = await makeRESTApiRequests({
      endpoint: ENDPOINTS.GET_PROFIT_AND_LOSS_JOB(id),
      method: "GET",
    });

    if (error) {
      setLoading(false);
      return toast.error(error);
    }

    setValue(response.profit);
    setLoading(false);
  };

  useEffect(() => {
    if (id) {
      fetchProfitOrLoss();
    }
  }, [id]);

  return (
    <div className="px-3">
      {loading ? (
        <div className="text-center">
          <Spinner animation="border" size="sm" />
        </div>
      ) : (
        <StatRow amount={value} />
      )}
    </div>
  );
}
